import { AnyAction } from 'redux'
import { WebsiteSettingsState } from 'src/shared/types/website-settings-types'

const defaultReducerState: WebsiteSettingsState = {
  websiteStyles: undefined,
  websiteThemesList: undefined,
  websiteTheme: undefined,
  websiteId: undefined,
  websiteLayouts: [],
  websiteLayoutPageId: undefined,
  websiteLocales: [],
  websiteDraftTheme: null,
}

export const websiteSettingsReducer = (
  // biome-ignore lint/style/useDefaultParameterLast: <explanation>
  state: WebsiteSettingsState = defaultReducerState,
  action: AnyAction,
): WebsiteSettingsState => {
  switch (action.type) {
    default:
      return state
  }
}
